import { Card, CardContent, Typography, Box, Skeleton } from "@mui/material";
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer, Legend } from "recharts";
import { CHART_COLORS, formatCurrency, formatStatusLabel } from "../constants";

interface PaymentGatewayChartProps {
  data: any;
  loading: boolean;
}

const SOURCE_COLORS: Record<string, string> = {
  Stripe: CHART_COLORS.primary,
  Adyen: CHART_COLORS.teal,
  "Bank Transfer": CHART_COLORS.warning,
  Card: CHART_COLORS.purple,
  Online: CHART_COLORS.info,
  Other: CHART_COLORS.slate,
};

const PaymentGatewayChart = ({ data, loading }: PaymentGatewayChartProps) => {
  if (loading) {
    return (
      <Card sx={{ height: "100%", borderRadius: 2, boxShadow: "0 1px 3px 0 rgba(0,0,0,.1)" }}>
        <CardContent sx={{ p: 2.5 }}>
          <Skeleton width="40%" height={24} />
          <Skeleton variant="circular" width={200} height={200} sx={{ mt: 3, mx: "auto" }} />
        </CardContent>
      </Card>
    );
  }

  const chartData = data?.bySource?.map((item: any) => ({
    name: formatStatusLabel(item.source),
    value: item.totalAmount,
    count: item.count,
    color: SOURCE_COLORS[item.source] || CHART_COLORS.slate,
  })) || [];

  return (
    <Card sx={{ height: "100%", borderRadius: 2, boxShadow: "0 1px 3px 0 rgba(0,0,0,.1)" }}>
      <CardContent sx={{ p: 2.5 }}>
        <Typography variant="subtitle1" fontWeight={600} sx={{ mb: 2 }}>
          Payment Gateways
        </Typography>
        {chartData.length > 0 ? (
          <ResponsiveContainer width="100%" height={280}>
            <PieChart>
              <Pie
                data={chartData}
                cx="50%"
                cy="45%"
                innerRadius={55}
                outerRadius={90}
                paddingAngle={3}
                dataKey="value"
              >
                {chartData.map((entry: any, index: number) => (
                  <Cell key={`cell-${index}`} fill={entry.color} />
                ))}
              </Pie>
              <Tooltip
                formatter={(value: any, _name: any, props: any) => [
                  `${formatCurrency(value)} (${props.payload.count} orders)`,
                  props.payload.name,
                ]}
                contentStyle={{ borderRadius: 8, fontSize: 13 }}
              />
              <Legend
                verticalAlign="bottom"
                iconType="circle"
                iconSize={10}
                formatter={(value: string) => <span style={{ fontSize: 12, color: "#555" }}>{value}</span>}
              />
            </PieChart>
          </ResponsiveContainer>
        ) : (
          <Box sx={{ height: 280, display: "flex", alignItems: "center", justifyContent: "center" }}>
            <Typography color="text.secondary">No payment data</Typography>
          </Box>
        )}
      </CardContent>
    </Card>
  );
};

export default PaymentGatewayChart;
